export default {
  env: 'dev',
  scrollingUrl: 'http://localhost:3000',
  apiBaseUrl: 'https://cenkovic.chronotrack.com/api'
};



// WEBPACK FOOTER //
// ./configs.local.js